import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import CssBaseline from "@mui/material/CssBaseline";
import {
  ThemeProvider,
  Theme,
  StyledEngineProvider,
} from "@mui/material/styles";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import theme from "./globals/design-system/theme";

declare module "@mui/material/styles" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

(async () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_PUBLIC_DNS,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });

  /**
   * This is a temporary solution to persist ld flag across user sessions.
   */
  let value = { key: "anonymous", name: "operator", slug: "", plan: "" };

  try {
    const storedValue = window.localStorage.getItem("ldKey");
    value = storedValue ? JSON.parse(storedValue) : {};
  } catch (error) {
    console.error("Error reading localStorage key 'ldKey':", error);
  }

  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID as string,
    context: {
      kind: "operator",
      key: value.key || "",
      name: value.name || "",
      slug: value.slug || "",
      plan: value.plan || "",
    },
  });

  ReactDOM.render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LDProvider>
          <App />
        </LDProvider>
      </ThemeProvider>
    </StyledEngineProvider>,
    document.getElementById("root")
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
})();
